import {
  ButtonBase,
  CardContent,
  CardHeader,
  Grid,
  makeStyles,
  Typography,
} from '@material-ui/core';
import React from 'react';
import CardActions from '@material-ui/core/CardActions';
import Loading from 'components/Loading';
import { RolesEnum, CompanyData } from 'modules/authenticate/interfaces';
import clsx from 'clsx';
import { cyrb53Hash } from 'utils/helpers';
import styles from './styles';

const useStyles = makeStyles(styles);

export interface FooterProps {
  name: string;
  icon?: React.ReactNode;
  disabled?: boolean;
  link?: string;
  onClick?: () => void;
}

export interface ExhibitionCardUnstyledProps {
  title?: string;
  type?: string;
  value?: any;
  contentImg?: React.ReactNode;
  footer: FooterProps[] | undefined;
  hasType?: boolean;
  loading?: boolean;
  role?: RolesEnum;
  companySelected?: CompanyData | null;
}

const ExhibitionCardUnstyled = ({
  title,
  value,
  footer,
  contentImg,
  type,
  hasType,
  loading = false,
  role,
  companySelected,
}: ExhibitionCardUnstyledProps) => {
  const classes = useStyles();

  return (
    <Grid data-testid={'autosky-exhibition-card-unstyled'}>
      <Grid item xs={12}>
        <CardHeader
          className={classes.header}
          title={title}
          subheader={hasType && type}
        />
      </Grid>
      {loading ? (
        <Grid container alignItems="center" justify="center">
          <Loading size={15} />
        </Grid>
      ) : (
        <>
          <CardContent className={classes.cardContent}>
            <Typography
              className={clsx(classes.value, {
                [classes.valueGreen]:
                  role === RolesEnum.admin && !companySelected,
                [classes.valueGray]:
                  role === RolesEnum.superAdmin && !companySelected,
                [classes.valueBlue]:
                  role === RolesEnum.operator && !companySelected,
                [classes.valueYellow]: companySelected,
              })}
              variant="h4"
              component="h2"
            >
              {value}
            </Typography>
            {contentImg && <>{contentImg}</>}
          </CardContent>
        </>
      )}
      {footer && (
        <CardActions>
          {footer.map(item => (
            <ButtonBase
              onClick={item?.onClick}
              disabled={item?.disabled}
              key={cyrb53Hash(item.name)}
            >
              {item.icon}
              <Typography>{item.name}</Typography>
            </ButtonBase>
          ))}
        </CardActions>
      )}
    </Grid>
  );
};

export default ExhibitionCardUnstyled;
